export class ClinicDetailsModel {
    clinic_name: string
    clinic_address: string
    city: string
    state: string
    clinic_zip: string
    clinic_phone: string
    invoice_message: string

    constructor(
        clinic_name: string,
        clinic_address: string,
        city: string,
        state: string,
        clinic_zip: string,
        clinic_phone: string,
        invoice_message: string,
    ) {
        this.clinic_name = clinic_name
        this.clinic_address = clinic_address
        this.city = city
        this.state = state
        this.clinic_zip = clinic_zip
        this.clinic_phone = clinic_phone 
        this.invoice_message = invoice_message 
    }
} 